/**
 * Vitrine: superfície pública do módulo. NÃO importa de planos, cobrança nem Inbox (regra de lint): a casca entrega as
 * portas (`contract`, `startExperiment`, `talkToSales`, `requestFromAdmin`) e o módulo só mostra e pede.
 *
 * `ModuleShowcase` é carregado sob demanda (TDD §6): quem não está no modo Otto, e quem já tem o módulo, nunca baixa a
 * página, as animações nem as capturas. Quem usa precisa de um `<Suspense>`. O catálogo (`showcaseModule`) é leve e síncrono,
 * porque o portão decide com ele se mostra a vitrine.
 */
import { lazy } from 'react';

export const ModuleShowcase = lazy(() => import('./ModuleShowcase.jsx'));
export { SHOWCASE_MODULES, showcaseModule, showcaseModuleByNavKey } from './catalog.js';
export { resolveActions } from './actions.js';
